import React from 'react';
import { HelpIcon } from './HelpIcon';

export function TextField({ id, label, value, onChange, error, helpText, placeholder, required, readOnly, maxLength, multiline, type = 'text' }) {
  const cls = `field-input${error ? ' field-error-border' : ''}${readOnly ? ' field-readonly' : ''}`;
  const shared = {
    id: `field-${id}`,
    value: value ?? '',
    placeholder,
    readOnly,
    maxLength,
    'aria-invalid': !!error,
    className: cls,
    onChange: (e) => onChange(e.target.value),
  };
  return (
    <div className="fw">
      <label className="fl" htmlFor={`field-${id}`}>
        {label}
        {required && <span className="req"> *</span>}
        {helpText && <HelpIcon text={helpText} id={id} />}
      </label>
      {multiline ? <textarea {...shared} rows={3} /> : <input type={type} {...shared} />}
      {error && <span className="ferr" role="alert">{error}</span>}
      {maxLength && !error && <span className="fcount">{(value ?? '').length}/{maxLength}</span>}
    </div>
  );
}
